import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { BrokerFiltersSchema, BrokerListItemSchema, BrokerRetrieveCriteriaSchema, BrokersMetadataSchema } from './schemas';

const c = initContract();

export const brokerContract = c.router({
  retrieveBrokers: {
    method: 'POST',
    path: '/broker/retrieve-brokers',
    body: z.object({
      criteria: BrokerRetrieveCriteriaSchema.optional(),
    }),
    responses: {
      200: z.object({
        brokers: z.array(BrokerListItemSchema),
      }),
    },
  },

  retrieveBrokersMetadata: {
    method: 'POST',
    path: '/broker/retrieve-brokers-metadata',
    body: z.object({
      filters: BrokerFiltersSchema,
    }),
    responses: {
      200: z.object({
        metadata: BrokersMetadataSchema,
      }),
    },
  },

  retrieveBrokerDetails: {
    method: 'GET',
    path: '/broker/retrieve-broker-details/:id',
    pathParams: z.object({
      id: z.string(),
    }),
    responses: {
      200: z.object({
        broker: BrokerListItemSchema,
      }),
      404: z.object({ message: z.string() }),
    },
  },
});
